import { Button, ButtonGroup, MenuItem } from "@blueprintjs/core";
import { ItemRenderer, Select } from "@blueprintjs/select";
import autobind from "autobind-decorator";
import { arrayMove } from 'core/util/ArrayUtils';
import { IFieldProps } from 'decorator-form';
import { pickBy } from 'lodash';
import * as React from "react";
import { connect } from 'react-redux';
import ComponentRegistry from "react-registry/dist/lib/ComponentRegistry"; // TODO update registry for proper access
import { bindActionCreators } from 'redux';

import { IconNames } from "@blueprintjs/icons";
import TextWidget from "common/form/widgets/TextWidget";
import * as configActions from 'core/actions/configActions';
import PageConfig from "panels/page/PageConfig";
import UrlUtil from "../../../core/util/UrlUtil";
import { FlexJustify } from "../../fragments/Flex";

export interface IPagesFieldProps extends IFieldProps<IMenuPage[]> {
	actions: any;
	pages: {};
	availablePages: IPage[];
}

interface IPage extends PageConfig {
	instance: string;
	editName: string;
}

export interface IMenuPage {
	instance: string;
	path: string;
}

interface IPagesFieldState {
	selected: IMenuPage;
}

// Define a custom component for handling the root position object
class PagesField extends React.Component<IPagesFieldProps, IPagesFieldState> {

	constructor(props: IPagesFieldProps) {
		super(props);
		this.state = {selected: {path: "", instance: null}};
	}

	@autobind
	public removePage(instance: string) {

		const newChildren = this.props.formData.filter((p) => p.instance !== instance);
		this.props.onChange(newChildren);
	}

	@autobind
	public addPage() {
		const { instance } = this.state.selected;

		if(instance && this.props.formData.filter((p) => p.instance === instance).length <= 0) {

				this.props.onChange([...this.props.formData, this.state.selected]);

		} else {
			alert("No page or duplicate page selected");
		}
	}

	@autobind
	public sortPage(oldIndex: number, newIndex: number) {
		this.props.onChange(arrayMove([...this.props.formData], oldIndex, newIndex));
	}

	@autobind
	private selectPage(page: IPage) {
		this.setState({selected: {...this.state.selected, instance: page.instance}});
	}

	@autobind
	private onPathChange(path: string) {
		this.setState({selected: {...this.state.selected, path}});
	}

	public render() {
		const { formData, pages } = this.props;
		const { selected } = this.state;


		const panelItems = formData.map((p, i) => {

			const page = this.props.availablePages.find((e) => e.instance === p.instance);

			return <div key={p.instance}>
				<FlexJustify>
					<p>
						<div style={{fontWeight: "bold"}}>{page.label}</div>
						<div>({UrlUtil.getLink(p.path, page.path)})</div>
					</p>

					<ButtonGroup>
						{i > 0 && (
							<Button onClick={() => this.sortPage(i, i - 1)} icon={IconNames.CHEVRON_UP} />
						)}

						{i < formData.length - 1 && (
							<Button onClick={() => this.sortPage(i, i + 1)} icon={IconNames.CHEVRON_DOWN} />
						)}

						<Button onClick={() => this.removePage(p.instance)} icon={IconNames.CROSS} />
					</ButtonGroup>
				</FlexJustify>
			</div>;
		});

		const PageSelect = Select.ofType<IPage>();

		const selectedPage = selected ? this.props.availablePages.find((p) => p.instance === selected.instance) : {label: "Select page"};

		return (
			<div>
				<h4>Pages</h4>

				{panelItems}

				<h5>Add page:</h5>
				<PageSelect
					items={this.props.availablePages}
					noResults={<MenuItem disabled={true} text="No results." />}
					onItemSelect={this.selectPage}
					itemRenderer={renderPanelItem}

				>
					<Button
						text={selectedPage ? selectedPage.label : "Select page"}
						rightIcon="double-caret-vertical"
					/>
				</PageSelect>

				<TextWidget
					value={selected.path}
					onChange={this.onPathChange}
					readonly={false}
					autofocus={false}
					options={{}}
					placeholder="Path prefix"
				/>

				<Button
					text="Add"
					onClick={() => this.addPage() }
				/>
			</div>
		);
	}
}

const renderPanelItem: ItemRenderer<IPage> = (item, { handleClick, modifiers }) => {
	return (
		<MenuItem
			active={modifiers.active}
			key={item.path}
			label={item.editName}
			onClick={handleClick}
			text={item.label}
		/>
	);
};

const mapStateToProps = (state, ownProps: IPagesFieldProps): any => {

	const instances = ownProps.formData.map((p) => p.instance);

	const availablePages = Object.entries(state.config.panels).filter(([k, v]: any) =>
		"page" === v.id
	).map(([k, v]) => (
		{instance: k, ...v}
	));

	return {
		availablePages
	};
};

const mapDispatchToProps = (dispatch) => {
	return { actions: bindActionCreators(configActions as any, dispatch) };
};

export default connect<IPagesFieldProps>(mapStateToProps, mapDispatchToProps)(PagesField);



// WEBPACK FOOTER //
// ./src/common/form/fields/PagesField.tsx